export default function (context, name) {
    let setting = context.state[name];
    setting.type = setting.type==='Tiled'?'Custom':'Tiled';
}